module.exports = __webpack_public_path__ + "img/code.4058de06.png";